import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Container, Paper, Typography } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import NewPasswordForm from '../components/NewPasswordForm';
import { useAuth } from '../../../shared/context/AuthContext';

const NewPasswordPage = () => {
  const navigate = useNavigate();
  const {
    newPasswordRequired,
    isAuthenticated,
    loading,
    error,
    completeNewPassword,
    clearError,
  } = useAuth();

  // If user lands here without a challenge, redirect to login
  useEffect(() => {
    if (!newPasswordRequired && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [newPasswordRequired, isAuthenticated, navigate]);

  // After successful password change, redirect to dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    return () => {
      clearError();
    };
  }, [clearError]);

  const handleNewPassword = (newPassword) => {
    completeNewPassword(newPassword);
  };

  if (!newPasswordRequired) {
    return null;
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'warning.main' }}>
              <LockResetIcon />
            </Avatar>
            <Typography component="h1" variant="h5" sx={{ mb: 1 }}>
              Set New Password
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2, textAlign: 'center' }}
            >
              Your account requires a new password. Please set a permanent
              password to continue.
            </Typography>
            <NewPasswordForm
              onSubmit={handleNewPassword}
              loading={loading}
              error={error}
            />
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NewPasswordPage;
